import { NavItemWrapper, NavWrapper } from './styles';
import { Nav } from 'react-bootstrap';
import { PreSelectSection } from '@nkr/enums/index';
import { IRowData } from './models';
import { IRecipient } from '@nkr/models/index';

interface IProps {
    activeTab: PreSelectSection,
    recipient: IRecipient,
    data: IRowData[],
    onTabChange: (tab: PreSelectSection) => void
}

const SectionFilters = (props: IProps) => {
    const getFilterCounts = () => {
        let recipientAge = parseInt(props.recipient.age);

        let counts = {
            potentialDonors: 0,
            avoidConflicts: 0,
            inMatch: 0,
            bioMatches: 0,
            all: 0
        };

        props.data.forEach(x => {
            let { donor: { isPotentialDonor, isBadPmpc, isHardToMatch, isInMatch, isBioMatch, isBadAboMatch, isBadAgeMatch, isBiologicalMatch, isAboCompatible, isPediatricAgeCutoff } } = x;

            if (isPotentialDonor == true || (recipientAge <= 21 && isBioMatch == true)) {
                counts.potentialDonors++;
            }

            if (isAboCompatible && !isBiologicalMatch && !isBadPmpc) {
                counts.avoidConflicts++;
            }

            //if (isInMatch == true && !isBadAboMatch && !isBadAgeMatch && isBioMatch && !isBadPmpc) {
            if (isInMatch == true && !isBadAboMatch && !isBadAgeMatch && isBioMatch && !isBadPmpc && ((recipientAge <= 21 && isPediatricAgeCutoff == false) || recipientAge > 21)) {
                counts.inMatch++;
            }

            if (isBioMatch == true) {
                counts.bioMatches++;
            }

            counts.all++;
        });

        return counts;
    };

    const section = props.activeTab;
    const counts = getFilterCounts();

    return (
        <div style={{ marginTop: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <NavWrapper activeKey={section} style={{ width: 'initial', borderBottom: '0 none' }} >
                <Nav bsStyle="tabs" onSelect={(e: any) => props.onTabChange(e)}>
                    <NavItemWrapper eventKey={PreSelectSection.PotentialDonors} inactive={section != PreSelectSection.PotentialDonors ? true : false}>
                        Potential Donors <sup style={{ fontSize: 11 }}>({counts.potentialDonors})</sup>
                    </NavItemWrapper>

                    <NavItemWrapper eventKey={PreSelectSection.AvoidConflict} inactive={section != PreSelectSection.AvoidConflict ? true : false}>
                        Avoid Conflict <sup style={{ fontSize: 11 }}>({counts.avoidConflicts})</sup>
                    </NavItemWrapper>

                    <NavItemWrapper eventKey={PreSelectSection.InMatch} inactive={section != PreSelectSection.InMatch ? true : false}>
                        In Match <sup style={{ fontSize: 11 }}>({counts.inMatch})</sup>
                    </NavItemWrapper>

                    <NavItemWrapper eventKey={PreSelectSection.BioMatch} inactive={section != PreSelectSection.BioMatch ? true : false}>
                        Bio Matches <sup style={{ fontSize: 11 }}>({counts.bioMatches})</sup>
                    </NavItemWrapper>

                    <NavItemWrapper eventKey={PreSelectSection.All} inactive={section != PreSelectSection.All ? true : false}>
                        All <sup style={{ fontSize: 11 }}>({counts.all})</sup>
                    </NavItemWrapper>
                </Nav>
            </NavWrapper>
        </div>
    )
}

export default SectionFilters;